import { useMemo } from 'react';

import { useSearchCauses } from 'core/Api';
import { useNavigate } from 'react-router-dom';
import { CauseDetail, CauseStoreCard, Divider, Stack, Text } from 'ui';

const PopularCauses = () => {
  const navigate = useNavigate();
  const { data: causes } = useSearchCauses({
    queryOptions: { searches: { trending: { value: true } } },
  });

  const causeList = useMemo(() => {
    return causes?.map((cause, index) => {
      const website = cause?.links?.find((link) => link.type == 'website')?.url;

      return (
        <Stack key={cause.uuid} gap={0}>
          <CauseStoreCard
            direction="column"
            imgSrc={cause.logo?.url}
            title={cause.name}
            info={{
              detail: <CauseDetail city={cause.city} state={cause.state} website={website} />,
            }}
            onClick={() => navigate(`/onboarding/causes/${cause.uuid}`)}
          />
          {index !== causes.length - 1 && <Divider size="sm" color="gray.0" mx="md" />}
        </Stack>
      );
    });
  }, [causes, navigate]);

  return (
    <Stack>
      <Text fz="18px" fw={600}>
        Popular in the US
      </Text>
      {causeList}
    </Stack>
  );
};
export { PopularCauses };
